import {Component, OnInit, ViewChild,Input} from '@angular/core';
import {BsModalService} from "ngx-bootstrap";
import {BsModalRef} from "ngx-bootstrap/modal/bs-modal-ref.service";
import {HelperService} from "../../services/helper.service";
import {RilrService} from "../../services/rilr.service";
import {TosterMessageService} from '../../services/toster-message.service';
import {NgxSpinnerService} from "ngx-spinner";
import {IOption} from "ng-select";
@Component({
  selector: 'app-safety-report',
  templateUrl: './safety-report.component.html',
  styleUrls: ['./safety-report.component.css'],
  providers: [RilrService, TosterMessageService, HelperService]
})
export class SafetyReportComponent implements OnInit {

  @Input() id: any;
    constructor(public bsModalRef: BsModalRef,
        private tosterMessageService: TosterMessageService,
        private rilrService: RilrService,
        private helperService: HelperService,
        private spinner: NgxSpinnerService,
        private modalService: BsModalService) {
}

companySystemID = this.helperService.getSelectedCompanyId();

public masterData: any = {};
public dbDataWithHeader: any = [];
public dbDataWithNoHeader: any = [];
public countryOption: any = [];
public disabled: any = false;
public monthDropdownDisabled: any = false;
public monthOption: any = [];
public yearOption: any = [];
public serviceLineArr: Array<IOption> = [];
public dateObj = new Date();
public currentYear = this.dateObj.getFullYear(); //current year
public previousYear = this.dateObj.getFullYear() - 1; //previous year
public currentMonth = this.dateObj.getMonth() + 1; //months from 1-12
public reportEmployeeAccess: any = {};
profile: any = {};
attachments: any = [];
fileChanges: boolean = false;
submitted: boolean = false;
mdata:any[]=[];


closeModal() {
    this.bsModalRef.hide();
    this.modalService.setDismissReason("scat_model_closed");
  }
  ngOnInit() {
    

    setTimeout(() => {
      //console.log(this.id);
      this.getFormData();
      }, 2000);

      
    //console.log('Printing this in ngOnInit', this);
   
    
  }
  detailsWithHeader:any[]=[];
  organizedData: any[] = [];
   alphabet = 'abcdefghijklmnopqrstuvwxyz';

   groupedData: { titleDescription: string; items: any[] }[] = [];

   groupData() {
  

   
  }



  printPage() {

    window.print();

  }






  organizeData(detailsWithHeader) {
    // Group data by 'titleDescription'
    const groupedData = this.groupBy(detailsWithHeader, 'titleDescription');

    // Sort groups alphabetically
    const sortedGroups = Object.keys(groupedData).sort();

    // Iterate over sorted groups, prefix items, and add to organizedData
    sortedGroups.forEach((groupKey) => {
      const group = groupedData[groupKey];
      let prefix = 'a';

      group.sort((a, b) => a.labelName.localeCompare(b.labelName));

      group.forEach((item) => {
        item.labelName = `${prefix}) ${item.labelName}`;
        this.organizedData.push(item);
        prefix = String.fromCharCode(prefix.charCodeAt(0) + 1);
      });
    });
  }

  // Utility function to group data by a specific property
  groupBy(array: any[], key: string) {
    return array.reduce((result, currentValue) => {
      (result[currentValue[key]] = result[currentValue[key]] || []).push(currentValue);
      return result;
    }, {});
  }


  filteredData: any;
  filterValue: any;
  created:any;

  getDataForValue(data,id) {
    this.filteredData = data.find(item => item.value === id);
    //console.log(this.filteredData);
  }
projectTitle:any;
lists:any[]=[];

  public getFormData() {
    
    const that = this;
    that.spinner.show();
    that.rilrService
      .monthlySafetyDataEntryData()
      .get({companySystemID: that.helperService.getSelectedCompanyId(), id: that.id})
      .subscribe((rsp) => {

        that.spinner.hide();
        const data = rsp.data.data;
        that.mdata=data.master;
        that.detailsWithHeader=data.detailsWithHeader;
        this.filterValue=data.master.project;
        //console.log(data.master.project);
       // that.projectTitle =that.getDataForValue(data.master.projects,data.master.project)
       // that.created = this.helperService.setSelectedValue(data.master.createdByUserSystemID);
//changes

this.lists = data.detailsWithHeader.reduce((result, item) => {

  //console.log(item);
  const key = item.titleDescription;

  if (!result[key]) {
    result[key] = [];
  }
  // result[key].push(item.titleDescription);
  result[key].push(item);

  return Object.values(result);
}, {});
//

        //console.log(that.projectTitle );
        that.countryOption = that.helperService.setSelect2DropDownOptions(data.country, "countryID", "countryName");
        that.monthOption = that.helperService.setSelect2DropDownOptions(data.months, "value", "label");
        that.yearOption = that.helperService.setSelect2DropDownOptions(data.years, "value", "label");
        that.dbDataWithHeader = data.detailsWithHeader;
        that.dbDataWithNoHeader = data.detailsWithHeader;

        that.detailsWithHeader = data.detailsWithHeader;

       that.organizeData( that.detailsWithHeader);

        //console.log(that.groupedData);
        that.profile = data.employee;
        if (that.id != 0) {
          that.masterData = data.master;
          that.masterData.serviceLineSystemID = [that.masterData.serviceLineSystemID];
          that.masterData.countryID = that.helperService.setSelectedValue(data.master.countryID);
          that.masterData.month = that.helperService.setSelectedValue(data.master.month);
          that.masterData.year = that.helperService.setSelectedValue(data.master.year);
          that.reportEmployeeAccess = data.access;
          if (that.masterData.month_by) {
            that.masterData.monthDes = that.masterData.month_by.monthDes;
          } else {
            that.masterData.monthDes = "";
          }
          if (data.master.confirmedYN == 1 || data.master.isDeleted == 1) {
            that.disabled = true;
          }
          
        } else {
          that.masterData.year = data.year;
          that.masterData.month = that.helperService.setSelectedValue(data.month);
          that.masterData.year = that.helperService.setSelectedValue(that.currentYear);
          if (that.profile.empCountry != 0) {
            that.masterData.countryID = that.helperService.setSelectedValue(that.profile.empCountry);
          }
        
        }
        that.masterData.isReopen = 0;
      }, (error) => {
        that.tosterMessageService.showError("Error", "course failed to load");
      });
      
  }

  
   
}



// WEBPACK FOOTER //
// /app/src/app/create-new-entry/monthly-safety-data-entry/safty-report.components.ts